var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoosters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FeaturedIcon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t#FeaturedIcon .st0{display:none;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 107,
    height: 100,
    id: "ZEJpQv",
    transform: "matrix(0.9903 0 0 0.9903 3.7163 7.1825)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 149,
    height: 153,
    id: "GBJatm_00000105385574701558158360000010142333644479843762_",
    transform: "matrix(0.9934 0 0 0.9934 120.4238 6.533359e-03)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.1,33.2c0-14-11.4-25.4-25.4-25.4S31.3,19.2,31.3,33.2s11.4,25.4,25.4,25.4S82.1,47.2,82.1,33.2z M68.1,49.9 c-0.4,0-0.9,0-1.3-0.2l-8.4-4.4c-0.7-0.3-1.4-0.3-2,0L48,49.7c-1,0.6-2.3,0.1-2.8-0.9C45,48.4,44.9,48,45,47.5l1.6-9.3 c0.1-0.6-0.1-1.4-0.6-1.8l-6.7-6.6c-0.9-0.8-0.9-2.1-0.1-3c0.3-0.4,0.7-0.5,1.2-0.6l9.3-1.3c0.7-0.2,1.3-0.6,1.6-1.2l4.2-8.5 c0.5-1.1,1.8-1.5,2.8-1c0.5,0.2,0.8,0.6,1,1l4.2,8.5c0.3,0.7,0.9,1.1,1.6,1.2l9.2,1.3c1.2,0.2,2,1.2,1.9,2.4 c-0.1,0.4-0.2,0.9-0.6,1.2l-6.8,6.6c-0.5,0.5-0.7,1.1-0.6,1.8l1.6,9.3C70,48.6,69.3,49.7,68.1,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,54.4C16.4,54.4,5,65.8,5,79.8s11.4,25.4,25.4,25.4s25.4-11.4,25.4-25.4S44.5,54.4,30.4,54.4z M49.9,75.2 c-0.1,0.4-0.2,0.9-0.6,1.2L42.5,83c-0.5,0.5-0.7,1.1-0.6,1.8l1.6,9.3c0.2,1.1-0.5,2.2-1.7,2.4c-0.4,0-0.9,0-1.3-0.2l-8.4-4.4 c-0.7-0.3-1.4-0.3-2,0l-8.4,4.4c-1,0.6-2.3,0.1-2.8-0.9c-0.2-0.4-0.3-0.8-0.2-1.3l1.6-9.3c0.1-0.6-0.1-1.4-0.6-1.8L13,76.4 c-0.9-0.8-0.9-2.1-0.1-3c0.3-0.4,0.7-0.5,1.2-0.6l9.3-1.3c0.7-0.2,1.3-0.6,1.6-1.2l4.2-8.5c0.5-1.1,1.8-1.5,2.8-1 c0.5,0.2,0.8,0.6,1,1l4.2,8.5c0.3,0.7,0.9,1.1,1.6,1.2l9.2,1.3C49.2,73,50,74,49.9,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,54.4c-14,0-25.4,11.4-25.4,25.4s11.4,25.4,25.4,25.4S109,93.8,109,79.8S97.6,54.4,83.6,54.4z M95.7,83 c-0.5,0.5-0.7,1.1-0.6,1.8l1.6,9.3c0.2,1.1-0.5,2.2-1.7,2.4c-0.4,0-0.9,0-1.3-0.2l-8.4-4.4c-0.7-0.3-1.4-0.3-2,0l-8.4,4.4 c-1,0.6-2.3,0.1-2.8-0.9c-0.2-0.4-0.3-0.8-0.2-1.3l1.6-9.3c0.1-0.6-0.1-1.4-0.6-1.8l-6.7-6.6c-0.9-0.8-0.9-2.1-0.1-3 c0.3-0.4,0.7-0.5,1.2-0.6l9.3-1.3c0.7-0.2,1.3-0.6,1.6-1.2l4.2-8.5c0.5-1.1,1.8-1.5,2.8-1c0.5,0.2,0.8,0.6,1,1l4.2,8.5 c0.3,0.7,0.9,1.1,1.6,1.2l9.2,1.3c1.2,0.2,2,1.2,1.9,2.4c-0.1,0.4-0.2,0.9-0.6,1.2L95.7,83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosters);
export default __webpack_public_path__ + "static/media/boosters.6d86fc263bf6f0121592ad7e3ce6617d.svg";
export { ForwardRef as ReactComponent };